
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';
import SignalR from '../../moreCore/System/SignalR/SignalR';

/*
    SignalR Implementierung als Basis für Customizing der weiteren Hub-Aufrufe.
    Phase 6 (R7/R42): ported to @microsoft/signalr — server->client via conn.on registrations,
    client->server via conn.invoke; getConnectionId() reads the HubConnection id (the value
    RequestManager sends as the ConnectionId header). Public API unchanged.
*/

class SignalR_Default extends compose(SignalR) {

    /**
     * Spezielle Hubs für diese Implementierung (registriert vor conn.start()).
    */
    protected _additionalHubs(): void {
        this._handlers["onUserMessage"] = lang.hitch(this, this._onSignalR__UserMessage);
        this._handlers["onSendToUser"] = lang.hitch(this, this._onSignalR__LiveCommand_SendToUser);
    }

    /*
     * Implementierung SERVER -> CLIENT
    */
    protected _onSignalR__UserMessage(message: string) {
        console.log("%cUserMessage", "color:yellow;background-color:red", message);

        this.showToast({
            title: "user message received",
            iconClass: "far fa-envelope",
            message: message,
            messageIcon: "far fa-envelope-open",
            options: {
                closeButton: true,
                timeout: -1
            }
        });
    }

    protected _onSignalR__LiveCommand_SendToUser(webuserId: string, commandTopic: string, message: string, targetConnectionId?: string) {
        let connectionId = null;
        try {
            connectionId = this.getConnectionId();
        } catch (ex) {

        }

        if (!!connectionId && !!targetConnectionId && targetConnectionId != connectionId) {
            console.info("live command rejected - wrong connection Id", connectionId, targetConnectionId, commandTopic, message);
            return;
        }
        console.log("%cLiveCommand", "color:yellow;background-color:blue", "webuser: " + webuserId, "topic: " + commandTopic, message, "cId: " + connectionId);

        if (window.sessionInfo?.sessionData) {
        }

        try {
            if (message) {
                message = JSON.parse(message);
            }
        } catch (ex) {
            console.warn("live command cannot be parsed", commandTopic, message, ex);
        }

        topic.publish("/LiveCommand/" + commandTopic, message);
    }

    /*
     * Implementierung CLIENT -> SERVER
    */
    public SendUserMessage(userid, message) {
        this._invoke("SendUserMessage", userid, message);
    }

    public getConnectionId(): string {
        let id = null;
        try {
            id = this._conn ? this._conn.connectionId : null;
        } catch (ex) {

        }
        return id;
    }

}

export default mdsWidget(SignalR_Default);
